import Cookies from "js-cookie";
import { clearPersistedSessionLoginId } from "./persistedLoginId";

// Reason shown on the login page after a forced logout. sessionStorage
// survives the full-page redirect to /login (Redux does not).
const LOGOUT_REASON_KEY = "qv_logout_reason";

const AUTH_COOKIES = [
  "loginDetails",
  "user_auth_record",
  "token_data",
  "superadmin_details",
];

const SESSION_STORAGE_PREFIXES = [
  "qv_dashboard_selectedOutletIds",
  "dashboardData",
  "new-po-listing-scroll-top",
  "new-po-listing-filters",
];

/** Removes every piece of signed-in state the Logout button clears. */
export function clearSession() {
  AUTH_COOKIES.forEach((name) => Cookies.remove(name));
  clearPersistedSessionLoginId();

  try {
    localStorage.removeItem("AllStore");
    localStorage.removeItem("quickvee_import_preferences");
    localStorage.removeItem("permissionPresetData");
    Object.keys(localStorage)
      .filter((key) => key.startsWith("admin_stores_"))
      .forEach((key) => localStorage.removeItem(key));
  } catch (e) {
    // storage unavailable (private mode / blocked) — nothing to clear
  }

  try {
    for (let i = sessionStorage.length - 1; i >= 0; i--) {
      const key = sessionStorage.key(i);
      if (!key) continue;
      const shouldClear = SESSION_STORAGE_PREFIXES.some(
        (prefix) => key === prefix || key.startsWith(`${prefix}_`)
      );
      if (shouldClear) sessionStorage.removeItem(key);
    }
  } catch (e) {
    // storage unavailable — nothing to clear
  }
}

export function saveLogoutReason(reason) {
  try {
    sessionStorage.setItem(LOGOUT_REASON_KEY, reason);
  } catch (e) {
    // storage unavailable — the login page just shows no reason
  }
}

/** Returns the saved reason once, then forgets it. */
export function consumeLogoutReason() {
  try {
    const reason = sessionStorage.getItem(LOGOUT_REASON_KEY) || "";
    sessionStorage.removeItem(LOGOUT_REASON_KEY);
    return reason;
  } catch (e) {
    return "";
  }
}
